<template>
  <div class="root">
    <div class="content">
      <p class="mode">
        <span>政策法规</span>
        <router-link to="/policiesRegulations">更多></router-link>
      </p>
      <ul class="xianwenList">
        <li v-for="(item, index) in list0" :key="index">
          <router-link :to="{ name: '政策法规详情', query: { id: item.id } }">
            <span class="dian"></span>
            <span class="xinwen" :title="item.title">{{ item.title }}</span>
            <span class="time">[{{ sub(item.logintime) }}]</span>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="content">
      <p class="mode">
        <span>交易指南</span>
        <router-link to="/tradingGuide">更多></router-link>
      </p>
      <ul class="xianwenList">
        <li v-for="(item, index) in list1" :key="index">
          <router-link :to="{ name: '交易指南详情', query: { id: item.id } }">
            <span class="dian"></span>
            <span class="xinwen" :title="item.title">{{ item.title }}</span>
            <span class="time">[{{ sub(item.logintime) }}]</span>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="content">
      <p class="mode">
        <span>土地咨询</span>
        <router-link to="/tudizixun">更多></router-link>
      </p>
      <ul class="xianwenList">
        <li v-for="(item, index) in list2" :key="index">
          <router-link :to="{ name: '土地咨询详情', query: { id: item.id } }">
            <span class="dian"></span>
            <span class="xinwen" :title="item.title">{{ item.title }}</span>
            <span class="time">[{{ sub(item.logintime) }}]</span>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="content">
      <p class="mode">
        <span>招商项目</span>
        <router-link to="/zhaoshangxiangmu">更多></router-link>
      </p>
      <ul class="xianwenList">
        <li v-for="(item, index) in list3" :key="index">
          <router-link :to="{ name: '招商项目详情', query: { id: item.id } }">
            <span class="dian"></span>
            <span class="xinwen" :title="item.title">{{ item.title }}</span>
            <span class="time">[{{ sub(item.logintime) }}]</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list0: [],
      list1: [],
      list2: [],
      list3: [],
    }
  },
  created() {
    // 政策法规数据
    let url0 = 'zhengcefagui'
    // console.log('政策法规');
    // console.log(this.ajax_url(url0).data);
    this.list0 = this.ajax_url(url0).data

    // 交易指南数据
    let url1 = 'jiaoyizhinan'
    // console.log('交易指南');
    // console.log(this.ajax_url(url1).data);
    this.list1 = this.ajax_url(url1).data

    // 土地资讯数据
    let url2 = 'tudizixun'
    // console.log('土地资讯');
    // console.log(this.ajax_url(url2).data);
    this.list2 = this.ajax_url(url2).data

    // 招商项目数据
    let url3 = 'zhaoshangxiangmu'
    // console.log('招商项目');
    // console.log(this.ajax_url(url3).data);
    this.list3 = this.ajax_url(url3).data
  },
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    sub(str) {
      return str.substr(0, 10)
    },
  },
}
</script>

<style scoped>
.root {
  min-height: 1180px;
  width: 100%;
  height: 922px;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-content: space-between;
}

.content {
  width: 621px;
  height: 443px;
  background: #ffffff;
  box-shadow: 0px 0px 24px 0px rgba(21, 21, 21, 0.1);
  overflow: hidden;
}

.mode {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px 0 37px;
  width: 554px;
  height: 80px;
  border-bottom: 1px solid #dbdbdb;
}

.mode > span {
  display: block;
  width: auto;
  height: 80px;
  font-size: 37px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2187ff;
  line-height: 80px;
}

.mode > a {
  display: block;
  width: auto;
  height: 80px;
  font-size: 25px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 80px;
}

.xianwenList {
  padding: 0 30px;
  padding-top: 11px;
  width: 561px;
  height: 336px;
  overflow: hidden;
}

.xianwenList > li {
  width: 561px;
  height: 47px;
  line-height: 38px;
  overflow: hidden;
}

.xianwenList > li > a {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  /* justify-content: space-between; */
  align-items: center;
  height: 22px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 22px;
  overflow: hidden;
}

.xianwenList .dian {
  width: 12px;
  height: 12px;
  background: #6fa3dc;
  border-radius: 50%;
}

.xianwenList .xinwen {
  padding-left: 13px;
  width: 329px;
  height: 22px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 22px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.xianwenList .time {
  padding-left: 68px;
  display: block;
  width: auto;
  height: 22px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 22px;
}
</style>
